module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-234.b14864b.woff2";